import EntityAccountPage from '@/pages/entityAccount/EntityAccountPage.vue'
import EntityAccountList from '@/pages/entityAccount/EntityAccountList.vue'
import EntityAccountFileList from '@/pages/entityAccount/EntityAccountFileList.vue'
import EntityAccountFileDetails from '@/pages/entityAccount/EntityAccountFileDetails.vue'
import EntityAccountDetails from '@/pages/entityAccount/EntityAccountDetails.vue'

export default [
  {
    path: '/entityAccountPage/:type',
    component: EntityAccountPage
  },
  {
    path: '/entityAccountList/',
    component: EntityAccountList
  },
  {
    path: '/entityAccountFileList/',
    component: EntityAccountFileList
  },
  {
    path: '/entityAccountFile/details/:idEngine/:idEntityAccountFile',
    component: EntityAccountFileDetails
  },
  {
    path: '/entityAccount/details/:idEntityAccount',
    component: EntityAccountDetails
  }
]
